var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _g, _path31, _path32, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleStoreButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_Mobile",
    "data-name": "Download/Mobile",
    xmlns: "http://www.w3.org/2000/svg",
    width: 144,
    height: 48,
    viewBox: "0 0 144 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Download_Mobile_style_",
    "data-name": "Download/Mobile (style)",
    width: 144,
    height: 48,
    rx: 7,
    fill: "#141416"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_353BA9E3-FAE3-45B6-ADB1-C40C4A9A975E",
    "data-name": "353BA9E3-FAE3-45B6-ADB1-C40C4A9A975E",
    d: "M1.723,0V2.749H0v1.8H1.723v6.126c0,2.092.946,2.929,3.327,2.929a6.913,6.913,0,0,0,1.165-.11V11.714a7.051,7.051,0,0,1-.817.05c-1.066,0-1.534-.5-1.534-1.634V4.552H6.216v-1.8H3.865V0Z",
    transform: "translate(96.108 23.041)",
    fill: "#fcfcfd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "E72BB604-0129-4FFF-8ACF-0285BC8F1224",
    d: "M5.12,11.266c3.168,0,5.11-2.122,5.11-5.638C10.23,2.132,8.278,0,5.12,0S0,2.132,0,5.628C0,9.144,1.942,11.266,5.12,11.266Z",
    transform: "translate(103.268 25.531)",
    fill: "#fcfcfd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "_23452A33-50B6-4D2A-B591-1F1F3E7E76C2",
    "data-name": "23452A33-50B6-4D2A-B591-1F1F3E7E76C2",
    d: "M2.909,7.461C1.046,7.461,0,6.1,0,3.725,0,1.375,1.046,0,2.909,0S5.817,1.375,5.817,3.725,4.761,7.461,2.909,7.461Z",
    transform: "translate(105.479 27.434)",
    fill: "#141416"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "BA2902AD-AFE9-4677-8809-F1AB32B2C685",
    d: "M0,11.027H2.142v-6.4a2.542,2.542,0,0,1,2.769-2.55,5.889,5.889,0,0,1,1.2.129V.09A4.523,4.523,0,0,0,5.15,0,2.942,2.942,0,0,0,2.221,1.843H2.062V.179H0Z",
    transform: "translate(115.16 25.561)",
    fill: "#fcfcfd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "CA249492-3FD4-4808-AD46-C57B51C5F9F4",
    d: "M7.65,8.128A2.6,2.6,0,0,1,5.07,9.443c-1.713,0-2.819-1.205-2.889-3.108v-.12h7.66V5.469C9.841,2.062,8.019,0,5,0,1.942,0,0,2.2,0,5.668s1.9,5.6,5.01,5.6c2.48,0,4.213-1.2,4.7-3.138Z",
    transform: "translate(121.593 25.531)",
    fill: "#fcfcfd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "_769A3C5D-CC8A-4C7A-812F-23F05CC1BA93",
    "data-name": "769A3C5D-CC8A-4C7A-812F-23F05CC1BA93",
    d: "M0,11.253c.165,2.664,2.385,4.367,5.689,4.367,3.531,0,5.74-1.786,5.74-4.635,0-2.24-1.259-3.479-4.315-4.192l-1.641-.4C3.531,5.936,2.746,5.327,2.746,4.264c0-1.342,1.218-2.22,3.046-2.22,1.734,0,2.932.857,3.149,2.23h2.251C11.057,1.765,8.848,0,5.823,0,2.571,0,.4,1.765.4,4.419c0,2.189,1.229,3.49,3.923,4.119L6.246,9c1.972.465,2.839,1.146,2.839,2.282,0,1.321-1.363,2.282-3.221,2.282-1.993,0-3.376-.9-3.572-2.313Z",
    transform: "translate(83.787 21.329)",
    fill: "#fcfcfd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "_5A85CE0B-564B-4218-974C-03597B198AC5",
    "data-name": "5A85CE0B-564B-4218-974C-03597B198AC5",
    d: "M5.628,0A3.77,3.77,0,0,0,2.221,1.972H2.062V.179H0V14.633H2.142V9.383h.169a3.537,3.537,0,0,0,3.337,1.823c2.739,0,4.482-2.161,4.482-5.608S8.387,0,5.628,0Z",
    transform: "translate(55.974 25.561)",
    fill: "#fcfcfd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "E5EE2CCA-3B06-48D3-8040-61E015B5EE25",
    d: "M2.918,7.361C1.126,7.361,0,5.947,0,3.686S1.126,0,2.928,0s2.9,1.385,2.9,3.676S4.741,7.361,2.918,7.361Z",
    transform: "translate(58.076 27.484)",
    fill: "#141416"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "_4B90F8F6-2D06-4E1B-8FEE-7B2C54AF95EA",
    "data-name": "4B90F8F6-2D06-4E1B-8FEE-7B2C54AF95EA",
    d: "M5.628,0A3.77,3.77,0,0,0,2.221,1.972H2.062V.179H0V14.633H2.142V9.383h.169a3.537,3.537,0,0,0,3.337,1.823c2.739,0,4.482-2.161,4.482-5.608S8.387,0,5.628,0Z",
    transform: "translate(67.97 25.561)",
    fill: "#fcfcfd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "_1303D315-F816-4526-9E66-F2E7D6E048AD",
    "data-name": "1303D315-F816-4526-9E66-F2E7D6E048AD",
    d: "M2.919,7.361C1.126,7.361,0,5.947,0,3.686S1.126,0,2.928,0s2.9,1.385,2.9,3.676S4.741,7.361,2.919,7.361Z",
    transform: "translate(70.072 27.484)",
    fill: "#141416"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "F408EE6B-DF9F-4733-AD7A-80DE45F3DDE3",
    d: "M10.789,14.9h2.457L7.867,0H5.379L0,14.9H2.375l1.373-3.954H9.426Z",
    transform: "translate(41.343 21.69)",
    fill: "#fcfcfd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "_33F714B2-B134-4BD2-88E5-F5AA05A249A7",
    "data-name": "33F714B2-B134-4BD2-88E5-F5AA05A249A7",
    d: "M2.168,0h.176L4.5,6.3H0Z",
    transform: "translate(45.679 24.395)",
    fill: "#141416"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "_6AA30074-5E72-4606-951B-6B99DE187C05",
    "data-name": "6AA30074-5E72-4606-951B-6B99DE187C05",
    d: "M0,0V7.187H2.595c2.142,0,3.382-1.32,3.382-3.616C5.977,1.31,4.726,0,2.595,0Z",
    transform: "translate(42.781 10.453)",
    fill: "#fcfcfd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "_6C938184-67FA-4DA6-8A9B-011F62F30B64",
    "data-name": "6C938184-67FA-4DA6-8A9B-011F62F30B64",
    d: "M0,0H1.355A2.266,2.266,0,0,1,3.725,2.57c0,1.649-.867,2.585-2.371,2.585H0Z",
    transform: "translate(43.897 11.469)",
    fill: "#141416"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "_0FD658F3-E9D6-4AC0-9BF8-4FE18DBE6CD7",
    "data-name": "0FD658F3-E9D6-4AC0-9BF8-4FE18DBE6CD7",
    d: "M2.56,5.633c1.584,0,2.555-1.061,2.555-2.819S4.139,0,2.56,0A2.492,2.492,0,0,0,0,2.814C0,4.572.971,5.633,2.56,5.633Z",
    transform: "translate(49.996 12.112)",
    fill: "#fcfcfd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "D7142D51-B579-48AE-ADD6-77C41FD444A9",
    d: "M1.454,3.73C.523,3.73,0,3.048,0,1.863S.523,0,1.454,0,2.909.687,2.909,1.863,2.381,3.73,1.454,3.73Z",
    transform: "translate(51.102 13.063)",
    fill: "#141416"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "_81B386D4-6519-48A5-9F86-7A14C4A41C0A",
    "data-name": "81B386D4-6519-48A5-9F86-7A14C4A41C0A",
    d: "M7.516,0H6.445L5.478,4.139H5.394L4.278,0H3.252L2.137,4.139h-.08L1.086,0H0L1.494,5.424h1.1L3.71,1.429H3.8L4.916,5.424H6.026Z",
    transform: "translate(55.866 12.216)",
    fill: "#fcfcfd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "_4E8C13DC-4722-43E7-AE9C-7417F404F851",
    "data-name": "4E8C13DC-4722-43E7-AE9C-7417F404F851",
    d: "M0,5.528H1.071V2.356A1.244,1.244,0,0,1,2.366.981c.792,0,1.17.433,1.17,1.3V5.528H4.607V2.017A1.764,1.764,0,0,0,2.729,0,1.624,1.624,0,0,0,1.111.966h-.08V.1H0Z",
    transform: "translate(64.615 12.112)",
    fill: "#fcfcfd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "DACD2F74-AD67-4D28-8AC8-C6DA76CA7D7E",
    d: "M0,7.54H1.071V0H0Z",
    transform: "translate(70.908 10.1)",
    fill: "#fcfcfd"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "_880EB8AD-DE9C-48EC-A878-CD18A34D015C",
    "data-name": "880EB8AD-DE9C-48EC-A878-CD18A34D015C",
    d: "M2.56,5.633c1.584,0,2.555-1.061,2.555-2.819S4.139,0,2.56,0A2.492,2.492,0,0,0,0,2.814C0,4.572.971,5.633,2.56,5.633Z",
    transform: "translate(73.446 12.112)",
    fill: "#fcfcfd"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "_4AB36BC8-E68F-4E00-AA4C-7D2CF660E039",
    "data-name": "4AB36BC8-E68F-4E00-AA4C-7D2CF660E039",
    d: "M1.454,3.73C.523,3.73,0,3.048,0,1.863S.523,0,1.454,0,2.909.687,2.909,1.863,2.381,3.73,1.454,3.73Z",
    transform: "translate(74.552 13.063)",
    fill: "#141416"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "A145A649-5EA4-4187-840C-2DC46F954A13",
    d: "M1.808,5.618a1.825,1.825,0,0,0,1.629-.852h.085v.762H4.552V1.823C4.552.677,3.785,0,2.425,0,1.2,0,.319.6.209,1.529H1.245c.119-.383.533-.6,1.13-.6.732,0,1.111.324,1.111.9v.468l-1.469.085C.727,2.455,0,3.018,0,3.994A1.639,1.639,0,0,0,1.808,5.618Z",
    transform: "translate(79.67 12.112)",
    fill: "#fcfcfd"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "F740BC59-D7B0-473B-8337-355A33CFD59D",
    d: "M2.251,7.63a1.883,1.883,0,0,0,1.7-.946h.085V7.54H5.065V0H3.994V2.978h-.08a1.788,1.788,0,0,0-1.663-.951C.882,2.027,0,3.113,0,4.826S.872,7.63,2.251,7.63Z",
    transform: "translate(85.604 10.1)",
    fill: "#fcfcfd"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "_44C0358F-1261-4EB6-9A2B-F8565675DDE7",
    "data-name": "44C0358F-1261-4EB6-9A2B-F8565675DDE7",
    d: "M1.449,0c.9,0,1.459.712,1.459,1.843S2.351,3.681,1.449,3.681,0,2.988,0,1.838.548,0,1.449,0Z",
    transform: "translate(86.71 13.088)",
    fill: "#141416"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "FE8F55CE-9992-46F5-BCA9-9D283473D989",
    d: "M2.56,5.633c1.584,0,2.555-1.061,2.555-2.819S4.139,0,2.56,0A2.492,2.492,0,0,0,0,2.814C0,4.572.971,5.633,2.56,5.633Z",
    transform: "translate(95.053 12.112)",
    fill: "#fcfcfd"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "A8881488-F2BA-41E9-A231-BA0BA7C879AF",
    d: "M1.454,3.73C.523,3.73,0,3.048,0,1.863S.523,0,1.454,0,2.909.687,2.909,1.863,2.381,3.73,1.454,3.73Z",
    transform: "translate(96.159 13.063)",
    fill: "#141416"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "_4A9858D6-4BE4-4576-A37A-A3ECBCE3EA34",
    "data-name": "4A9858D6-4BE4-4576-A37A-A3ECBCE3EA34",
    d: "M0,5.528H1.071V2.356A1.244,1.244,0,0,1,2.366.981c.792,0,1.17.433,1.17,1.3V5.528H4.607V2.017A1.764,1.764,0,0,0,2.729,0,1.624,1.624,0,0,0,1.111.966h-.08V.1H0Z",
    transform: "translate(101.586 12.112)",
    fill: "#fcfcfd"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "_28C945BE-2842-4845-A28A-F6F7895D1B32",
    "data-name": "28C945BE-2842-4845-A28A-F6F7895D1B32",
    d: "M.862,0V1.375H0v.9H.862V5.339c0,1.046.473,1.464,1.664,1.464a3.46,3.46,0,0,0,.583-.055V5.857a3.528,3.528,0,0,1-.408.025c-.533,0-.767-.249-.767-.817V2.276H3.108v-.9H1.932V0Z",
    transform: "translate(110.263 10.867)",
    fill: "#fcfcfd"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "E69410FD-C514-4D78-91E5-536FDFBA836D",
    d: "M0,7.54H1.071V4.373A1.266,1.266,0,0,1,2.435,3c.757,0,1.16.438,1.16,1.3V7.54H4.667v-3.5A1.786,1.786,0,0,0,2.8,2.017a1.67,1.67,0,0,0-1.654.971H1.061V0H0Z",
    transform: "translate(114.808 10.1)",
    fill: "#fcfcfd"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "_056856DB-86C3-4F7D-948C-7B31A001869B",
    "data-name": "056856DB-86C3-4F7D-948C-7B31A001869B",
    d: "M3.825,4.064a1.3,1.3,0,0,1-1.29.657A1.433,1.433,0,0,1,1.091,3.168v-.06h3.83V2.734C4.921,1.031,4.009,0,2.5,0,.971,0,0,1.1,0,2.834s.951,2.8,2.505,2.8A2.2,2.2,0,0,0,4.856,4.064Z",
    transform: "translate(120.842 12.112)",
    fill: "#fcfcfd"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Apple_logo",
    "data-name": "Apple logo",
    transform: "translate(11.966 10.465)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "A8947C9E-560B-47CE-AF98-9C149F57D6DC",
    d: "M17.757,7.593a5.987,5.987,0,0,1,2.828-4.982A6.154,6.154,0,0,0,15.8.022c-2.015-.212-3.969,1.206-5,1.206C9.753,1.227,8.172.043,6.47.078A6.431,6.431,0,0,0,1.1,3.351c-2.321,4.018-.59,9.923,1.633,13.171,1.112,1.59,2.412,3.367,4.113,3.3,1.664-.069,2.286-1.061,4.3-1.061,1.991,0,2.574,1.061,4.309,1.021,1.786-.029,2.911-1.6,3.985-3.2a13.157,13.157,0,0,0,1.822-3.711A5.789,5.789,0,0,1,17.757,7.593Z",
    transform: "translate(0 6.303)",
    fill: "#fcfcfd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_1AB3063C-BFE6-48AC-89E0-DFEDFC6A2A1A",
    "data-name": "1AB3063C-BFE6-48AC-89E0-DFEDFC6A2A1A",
    d: "M3.9,4.189A5.847,5.847,0,0,0,5.233,0,5.949,5.949,0,0,0,1.384,1.992,5.614,5.614,0,0,0,.011,6.025,4.977,4.977,0,0,0,3.9,4.189Z",
    transform: "translate(10.583)",
    fill: "#fcfcfd"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "E0571E8C-2AF7-4965-9CEF-60FCFBF8DF82",
    d: "M2.809,0A2.617,2.617,0,0,1,5.478,2.809H0A2.773,2.773,0,0,1,2.809,0Z",
    transform: "translate(123.775 27.354)",
    fill: "#141416"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "_05EE5BA5-F643-434A-8977-2C2D79EF4832",
    "data-name": "05EE5BA5-F643-434A-8977-2C2D79EF4832",
    d: "M1.4,0A1.308,1.308,0,0,1,2.739,1.4H0A1.387,1.387,0,0,1,1.4,0Z",
    transform: "translate(121.933 13.023)",
    fill: "#141416"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "_7F13FAF0-4923-4469-930C-1E509865E6EE",
    "data-name": "7F13FAF0-4923-4469-930C-1E509865E6EE",
    d: "M1.006,1.639C.423,1.639,0,1.355,0,.867S.339.134,1.086.085L2.411,0V.453A1.278,1.278,0,0,1,1.006,1.639Z",
    transform: "translate(80.746 15.19)",
    fill: "#141416"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleStoreButton);
export default __webpack_public_path__ + "static/media/appleStoreButton.72ac0f2fea24e8315279f5cd17f1ac09.svg";
export { ForwardRef as ReactComponent };